import { atom } from "recoil";
import { ResponseGetAllStatusResponse } from "../../services/OpenAPI";

export const statusListAtom = atom<{
  statusList: ResponseGetAllStatusResponse[] | null;
}>({
  key: "statusListsAtom",
  default: {
    statusList: null,
  },
});
